export const Unit =
{
    Unknown : 0,
    Millimeter : 1,
    Centimeter : 2,
    Meter : 3,
    Inch : 4,
    Foot : 5
};
